import {getActionType, TYPES} from '../util/redux';
import {UserType} from '../action/user';

const initState = {
    request : true,
    profile : undefined,
    data : undefined,
    msg : '',
    logout_request : false,
    formEle : null,
    count : 0,
    cashEncourageState: null,
}
const type1 = getActionType(UserType, 'request');
const type2 = getActionType(UserType, 'success');
const type3 = getActionType(UserType, 'fail');
const type4 = getActionType(UserType, 'clear');
const type5 = getActionType(UserType, 'lgoutrequest');
const type6 = getActionType(UserType, 'lgoutcomplete');
const type7 = getActionType(UserType, 'saveformele');
const type8 = getActionType(UserType, 'messagecount');
const type9 = getActionType(UserType, 'agreecomp');
const type10 = getActionType(UserType, 'setcustomwm');

const cashEncourageStateSuccess = getActionType(UserType, 'cashEncourageStateSuccess');
const cashEncourageStateFail = getActionType(UserType, 'cashEncourageStateFail');


export default function userReducer(state = initState, action){
    let {type, payload} = action;
    switch(type){
        case type1:
            return {
                ...state,
                request : true,
                msg : ''
            }
      case type2:
            let resData = payload.data;
            //console.log(payload, resData);
            let profile = {
                "userId" : resData.uid,
                "nickName" : resData.nickName,
                "avatarUrl" : resData.avatarUrl
            };
            let data = {...resData};
            return {
                ...state,
                request : false,
                profile,
                data,
                msg : ''
            }
        case type3:
            let rcode = payload.code;
            let rmsg = payload.msg;
            return {
                ...state,
                request : false,
                msg : rmsg
            }
        case type5:
            return {
                ...state,
                logout_request : true
            }
        case type6:
            return {
                ...state,
                logout_request : false
            }
        case type7:
            return {
                ...state,
                formEle : payload
            }
        case type8:
            let {comment, forward, msg, notice} = payload;
            let totalNum = comment + forward + msg + notice;
            return {
                ...state,
                count : totalNum
            }
        case type9:
            let nsuccess = payload.success;
            let adata = state.data;
            return {
                ...state,
                data : {
                    ...adata,
                    publishAgreement : nsuccess ? true : false
                }
            }
        case type10:
            let open = payload.open;
            let bdata = state.data;

            return {
                ...state,
                data : {
                    ...bdata,
                    'openCustomWatermark': open,
                }
            }
        case cashEncourageStateSuccess: {
          let resData = payload.data;
          return {
            ...state,
            cashEncourageState: resData
          }
        }
        case cashEncourageStateFail: {
          return {
            ...state,
            cashEncourageState: null
          }
        }
        case TYPES.CLEAR_ALL:case type4:
            return {
                ...initState
            }
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./client/reducers/user.js